import React, { FC } from 'react'
import {
    StyledNav,
    StyledHeading,
    StyledNavList,
    StyledNavItem,
    StyledLink,
    StyledQuickLinks,
} from './QuickLinks.styled'
import { NavEvent, NavEventArgs } from 'common/events/nav-event-types'
import { usePageEvents } from 'common/context-providers/pageEvent-context'
import { DataLayerEventName } from 'common/helpers/DataLayerEventName'
import { NavItem } from 'common/navigation'

export interface QuickLinksProps {
    links: NavItem[]
    onEvent: (event: NavEvent) => void
    hasBackgroundFill?: boolean
}

export const QuickLinks: FC<QuickLinksProps> = React.memo(
    ({ links, onEvent, hasBackgroundFill }) => {
        usePageEvents(() => {
            onEvent({
                type: DataLayerEventName.navAvailable,
                originator: 'QuickLinks',
                payload: {},
            })
        }, ['page-load-complete'])

        const handleClick = (args: NavEventArgs) => {
            onEvent({
                type: DataLayerEventName.navClicked,
                originator: 'QuickLinks',
                payload: {
                    navName: 'QuickLinks',
                    navLocation: 'Header',
                    navPos: args.navPos,
                    navText: args.navText,
                    navLink: args.navLink,
                },
            })
        }

        return (
            <StyledQuickLinks hasBackgroundFill={hasBackgroundFill || false}>
                <StyledNav>
                    <StyledHeading>In the News:</StyledHeading>
                    <StyledNavList>
                        {links.map((item, index) => (
                            <StyledNavItem key={item.link}>
                                <StyledLink
                                    to={item.link}
                                    target={item.newWindow ? '_blank' : undefined}
                                    rel={item.newWindow ? 'noopener' : undefined}
                                    onClick={() => {
                                        handleClick({
                                            navPos: index,
                                            navText: item.name,
                                            navLink: item.link,
                                        })
                                    }}
                                >
                                    {item.name}
                                </StyledLink>
                            </StyledNavItem>
                        ))}
                    </StyledNavList>
                </StyledNav>
            </StyledQuickLinks>
        )
    }
)
QuickLinks.displayName = 'QuickLinks'
